import { useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
const ListEndpoint = ApiEndpoints.newsletter.List;
const tableHeader = ["Date", "Name", "Email"];
const tbody = ["createdAt", "name", "email"];

export default function Newsletters() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.newsletters;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);


  const pagename = {
    name: 'Newsletters',
    user: 'Admin',
    innerpage: 'Newsletters'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
      </div>
    </>
  )
}
